import { createTheme } from "@mantine/core";
import { themeOverrides } from "./themeOverwrites";

export const theme = createTheme({
  ...themeOverrides,
});
